import { createUrlParamStore } from '@promoboxx/use-filter/dist/store/urlParamStore'
const urlParamStore = createUrlParamStore()
export default urlParamStore
